/**
 * @fileoverview React Context to hold static configuration received from the
 * Storm backend (could be employee view settings, product features, etc).
 *
 * @author Wyatt Lindquist (wlindquist@yext.com)
 */

export const StormContext = React.createContext({
  isViewAsEmployee: false,
});

/**
 * @param {{
 *   isViewAsEmployee?: boolean,
 *   children: (React.ReactNode | undefined),
 * }} props
 */
export function StormContextProvider({
  isViewAsEmployee,
  children,
}) {
  return (
    <StormContext.Provider value={{
      isViewAsEmployee: !!isViewAsEmployee,
    }}>
      {children}
    </StormContext.Provider>
  );
}

/**
 * @typedef {{
 *   isViewAsEmployee: boolean,
 * }}
 */
let StormContextValue;
